import { render, staticRenderFns } from "./PaymentRequestActions.vue?vue&type=template&id=be04f6a8&"
import script from "./PaymentRequestActions.vue?vue&type=script&lang=js&"
export * from "./PaymentRequestActions.vue?vue&type=script&lang=js&"
import style0 from "./PaymentRequestActions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports